/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.adminkeycloak.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.adminkeycloak = {};
proto.witbooking.backoffice.adminkeycloak.v1 = require('./adminkeycloak_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest,
 *   !proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse>}
 */
const methodDescriptor_AdminKeycloakAPI_GetUsersByPropertyTicker = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPI/GetUsersByPropertyTicker',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest,
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest,
 *   !proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse>}
 */
const methodInfo_AdminKeycloakAPI_GetUsersByPropertyTicker = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPIClient.prototype.getUsersByPropertyTicker =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPI/GetUsersByPropertyTicker',
      request,
      metadata || {},
      methodDescriptor_AdminKeycloakAPI_GetUsersByPropertyTicker,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.adminkeycloak.v1.GetUsersByPropertyTickerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPIPromiseClient.prototype.getUsersByPropertyTicker =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.adminkeycloak.v1.AdminKeycloakAPI/GetUsersByPropertyTicker',
      request,
      metadata || {},
      methodDescriptor_AdminKeycloakAPI_GetUsersByPropertyTicker);
};


module.exports = proto.witbooking.backoffice.adminkeycloak.v1;

